import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PaymentCart } from '@cargos/sprintpay-models';
import { finalize, take } from 'rxjs';
import { PaymentRequestService } from 'src/app/shared/services';

@Component({
    selector: 'app-delete-payment-cart',
    standalone: true,
    imports: [MatButtonModule, MatProgressSpinnerModule],
    templateUrl: './delete-payment-cart.component.html',
    styleUrl: './delete-payment-cart.component.scss',
})
export class DeletePaymentCartComponent {
    public deletingCart = false;
    public buttonName: string = 'button-delete-payment-cart';
    public buttonId: string = this.getButtonId();

    @Input() paymentCart: PaymentCart;
    @Input() set id(id: string) {
        this.buttonId = this.getButtonId(id);
    }

    private generateUniqueId(id?: string): string {
        return id && id.trim() !== '' ? id : Date.now().toString();
    }

    private getButtonId(id?: string): string {
        return `button-delete-payment-cart-${this.generateUniqueId(id)}`;
    }

    constructor(private paymentRequestService: PaymentRequestService) {}

    removeShipment(): void {
        if (!this.paymentCart.id || this.deletingCart) {
            return;
        }

        this.deletingCart = true;

        this.paymentRequestService
            .removePaymentRequest(this.paymentCart?.id)
            .pipe(
                take(1),
                finalize(() => {
                    this.deletingCart = false;
                })
            )
            .subscribe();
    }
}
